<template>
  <section class="accordion">
    <div
      v-for="(item, idx) in items"
      :key="'item' + idx"
      class="accordion-item-container"
    >
      <div
        class="accordion-item"
        :class="{'is-active': item.active}"
      >
        <dt class="accordion-item-title">
          <!--                    <button @click="toggle(idx)" class="accordion-item-trigger">-->
          <h4 class="accordion-item-title-text">
            {{ item.title }}
          </h4>

          <!--                        <span class="accordion-item-trigger-icon"></span>-->
          <!--                    </button>-->
        </dt>
        <dt class="accordion-item-title">
          <h4 v-if="item.status">
            Status: {{ item.status }} on {{ item.date || toDate }}
          </h4>
        </dt>
        <div
          class="accordion-item-details-inner"
          v-html="item.details"
        />
        <!--                <transition-->
        <!--                        name="accordion-item"-->
        <!--                        @enter="startTransition"-->
        <!--                        @after-enter="endTransition"-->
        <!--                        @before-leave="startTransition"-->
        <!--                        @after-leave="endTransition">-->
        <!--                    <dd v-if="item.active" class="accordion-item-details">-->
        <!--                        <div v-html="item.details" class="accordion-item-details-inner"></div>-->
        <!--                    </dd>-->
        <!--                </transition>-->
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AccordionComponent',
  props: {
    isMultiple: Boolean,
    accordionData: Array
  },
  computed: {
    items() {
      return [...this.accordionData];
    }
  },
  methods: {
    toggle(index) {
      this.items.map((item, currentIndex) => {
        // eslint-disable-next-line no-nested-ternary
        item.active = index === currentIndex ? !item.active : this.isMultiple ? item.active : false;
      });
    },
    startTransition(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    endTransition(el) {
      el.style.height = '';
    }
  }
};
</script>
<style scoped lang="scss">
    @media print{
        .accordion-item-details-inner{
            display: block;
            max-width: 1800px !important;
        }
        .accordion{
            max-width: 1800px !important;
        }
    }
    .accordion {
        display: flex;
        flex-direction: column;
        width: 100vw;
        max-width: 1024px;
        .accordion-item-container {
            + .accordion-item-container {
                margin-top: 15px;
            }
        }

        .accordion-item-trigger,
        .accordion-item-details-inner {
            padding: 0.75rem 1.25rem;
        }

        .accordion-item-title {
            position: relative;
            //box-shadow: 0 0 1px 0 rgb(8 8 8 / 75%);
            display: flex;
            align-items: center;

            h4 {
                font-size: 1.25rem;
                margin: 0;
                padding: 0;
            }
        }

        .accordion-item-trigger {
            cursor: pointer;
            width: 100%;
            text-align: left;
            background-color: transparent;
            border: none;
        }

        .accordion-item-trigger-icon {
            $size: 8px;
            display: block;
            position: absolute;
            top: 0; right: 1.25rem; bottom: 0;
            margin: auto;
            width: $size;
            height: $size;
            border-right: 2px solid #363636;
            border-bottom: 2px solid #363636;
            transform: translateY(-$size / 4) rotate(45deg);
            transition: transform 0.2s ease;

            .is-active & {
                transform: translateY($size / 4) rotate(225deg);
            }
        }

        .accordion-item-details {
            overflow: hidden;
            background-color: whitesmoke;
            -webkit-box-shadow: 0 1px 2px 0 rgb(0 0 0 / 18%);
            box-shadow: 0 1px 2px 0 rgb(0 0 0 / 18%);
        }
        .accordion-item-details-inner{
            width: 100%;
            max-width: 1024px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            flex-wrap: wrap;
            img{
                width: 100%;
                max-width: 1024px;
                margin: 0 auto;
            }
        }

        .accordion-item-enter-active,
        .accordion-item-leave-active {
            will-change: height;
            transition: height 0.2s ease;
        }

        .accordion-item-enter,
        .accordion-item-leave-to {
            height: 0 !important;
        }
    }
</style>
